import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Input,
  InputNumber,
  Modal,
  notification,
  Row,
  Select,
  Typography,
} from "antd";
import catchErrorFunction from "../../../utils/tms-catch-error/tms-catch-error";
import { withRouter } from "../../../utils/tms-with-router/tms-with-router";
import TmsCommonService from "../../../services/tms-common.service";
import { BaseContext } from "../../../contexts/BaseContext";
import Webcam from "react-webcam";
import VehicleServices from "../../../services/vehicle.services";
import { EmployeePassServices } from "../../../services/employee-scan";
import TmsPrintTicket from "../../../components/tms-print-ticket/tms-print-ticket";
import TmsStringUtils from "../../../utils/tms-string-utils/tms-string-utils";
import moment from "moment";

const EmployeePassAssign = ({ router }) => {
  const { userDetails } = useContext(BaseContext);

  const [buttonLoading, setButtonLoading] = useState(false);
  const [employeeExtID, setEmployeeExtID] = useState();
  const [departmentId, setDepartmentId] = useState();
  const [acceessGateId, setAccessGateId] = useState();
  const [accessGates, setAccessGates] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [noOfPersons, setNoOfPersons] = useState(null);
  const [name, setName] = useState("");
  const [designation, setDesignation] = useState();
  const [capturedImage, setCapturedImage] = useState(null);
  const [referrals, setReferrals] = useState([]);
  const [array, setArray] = useState([]);
  const [externalPrint, setExternalPrint] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [sevaDate, setSevaDate] = useState();

  const webcamRef = useRef(null);

  const printTicket = (data) => {
    setArray([
      ["Name", data?.name, { margin: "0" }],
      ["Designation", data?.designation, { margin: "0" }],
      ["Employee ID", data?.employeeExtID, { margin: "0" }],
      ["Seva Date", data?.sevaDate, { margin: "0" }],
      ["No of Persons", data?.noOfPersons, { margin: "0" }],
      ["Reporting Gate ID", data?.reportingGate, { margin: "0" }],
      ["Department", data?.department.departmentName, { margin: "0" }],
      ["Category", data?.categoryId, { margin: "0" }],
      ["footer", data?.transactionId, {}, {}, {}, null, data?.createdAt],
    ]);
  };

  const captureImage = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setCapturedImage(imageSrc);
  };

  const recaptureImage = () => {
    setCapturedImage(null);
  };

  const handleReferralChange = (index, field, value) => {
    const updatedReferrals = [...referrals];
    updatedReferrals[index] = {
      ...updatedReferrals[index],
      [field]: value,
    };
    setReferrals(updatedReferrals);
  };

  const handleNoOfPersonsChange = (value) => {
    setNoOfPersons(value);
    if (value && value > 0) {
      const newReferrals = Array(value)
        .fill(null)
        .map(() => ({ name: "", age: 0, gender: "male", aadharNo: "" }));
      setReferrals(newReferrals);
    } else {
      setReferrals([]);
    }
  };

  useEffect(() => {
    // Update referrals array when noOfPersons changes
    const newReferrals = Array(noOfPersons)
      .fill(null)
      .map(
        (_, index) =>
          referrals[index] || { name: "", age: 0, gender: "male", aadharNo: "" }
      );
    setReferrals(newReferrals);
  }, [noOfPersons]);

  const handleSubmit = async () => {
    if (!capturedImage) {
      notification.info({
        message: "Please capture a photo",
      });
      return;
    }

    // Convert the base64 image data to a binary Blob
    const binaryData = atob(capturedImage.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(binaryData.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < binaryData.length; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }

    const blob = new Blob([uint8Array], { type: "image/jpeg" });

    let formData = new FormData();
    formData.append("file", blob);

    const url = await TmsCommonService.uploadTempFile(
      formData,
      "person",
      userDetails.user.id
    );

    if (name == "" || designation == "") {
      notification.info({
        message: "Please fill all the fields",
      });
      setButtonLoading(false);
      return;
    }
    if (noOfPersons > 0) {
      const isReferralsValid = referrals.every(
        (ref) => ref.name && ref.age && ref.aadharNo
      );
      if (!isReferralsValid) {
        notification.info({
          message: "Please fill all referral details",
        });
        return;
      }
    }

    try {
      const data = await EmployeePassServices.createEmployeePass({
        departmentId: departmentId,
        employeeName: name,
        photoUrl: url.path,
        designation,
        reportingGate: acceessGateId,
        noOfPersons: noOfPersons,
        referrals: referrals,
        employeeExtID,
        sevaDate: moment(sevaDate).format("YYYY-MM-DD"),
      });
      notification.success({
        message: "Successfully created",
      });
      printTicket(data);
      setButtonLoading(false);
      setDesignation("");
      setName("");
      setNoOfPersons(0);
      setDepartmentId("");
      setAccessGateId("");
      setCapturedImage(null);
      setReferrals([]);
      setEmployeeExtID("");
      setSevaDate("");
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
      setButtonLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const departments = await VehicleServices.getDepartments();
      setDepartments(departments);
      const accessGates = await VehicleServices.getAccessGates();
      setAccessGates(accessGates);
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
    }
  };

  return (
    <>
      <Row justify="center">
        <Typography.Title>Assign Employee Pass </Typography.Title>
      </Row>
      <Divider />
      <Row>
        <Col span={12}>
          <div
            style={{
              gap: "10px",
              display: "flex",
              flexDirection: "column",
              marginTop: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                width: "100%",
              }}
            >
              <label>Name</label>
              <Input
                size="large"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter Name"
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                width: "100%",
              }}
            >
              <label>Employee ID</label>
              <Input
                size="large"
                value={employeeExtID}
                onChange={(e) => setEmployeeExtID(e.target.value)}
                placeholder="Enter Employee ID"
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                width: "100%",
              }}
            >
              <label>Designation</label>
              <Input
                size="large"
                value={designation}
                onChange={(e) => setDesignation(e.target.value)}
                placeholder="Enter Designation"
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                width: "100%",
              }}
            >
              <label>Seva Date </label>
              <DatePicker
                value={sevaDate}
                style={{ width: "100%" }}
                format="DD-MM-YYYY"
                disabledDate={(d) =>
                  !d || d.isBefore(TmsStringUtils.addDays(new Date(), -1))
                }
                onChange={(date) => {
                  setSevaDate(date);
                }}
                size="large"
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                width: "100%",
              }}
            >
              <label>No of Persons</label>
              <InputNumber
                maxLength={2}
                value={noOfPersons}
                min={0}
                size="large"
                onKeyDown={(e) =>
                  ["e", "E", "+", "-", "."].includes(e.key) &&
                  e.preventDefault()
                }
                style={{ width: "100%" }}
                placeholder={`Enter No Of Persons`}
                onChange={handleNoOfPersonsChange}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                width: "100%",
              }}
            >
              <label>Department</label>
              <Select
                size="large"
                value={departmentId}
                onChange={(e) => {
                  setDepartmentId(e);
                }}
                style={{ width: "100%" }}
                placeholder="Select Department"
              >
                {departments.map((department) => (
                  <Select.Option key={department.id} value={department.id}>
                    {department.departmentName}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                width: "100%",
              }}
            >
              <label>Access gate </label>
              <Select
                size="large"
                value={acceessGateId}
                onChange={(e) => {
                  setAccessGateId(e);
                }}
                style={{ width: "100%" }}
                placeholder="Select Access Gate"
              >
                {accessGates.map((accessGate) => (
                  <Select.Option key={accessGate.id} value={accessGate.id}>
                    {accessGate.name}
                  </Select.Option>
                ))}
              </Select>
            </div>

            <Divider />
            <h3>Referral Details</h3>

            {referrals.map((referral, index) => (
              <div key={index} style={{ marginBottom: "20px" }}>
                <p
                  strong
                  style={{
                    marginBottom: "2px",
                    textAlign: "left",
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  Person {index + 1}
                </p>
                <Row gutter={[20, 20]}>
                  <Col span={6}>
                    <label style={{ display: "flex" }}>Name</label>
                    <Input
                      value={referral.name}
                      onChange={(e) =>
                        handleReferralChange(index, "name", e.target.value)
                      }
                      placeholder="Enter Name"
                    />
                  </Col>
                  <Col span={6}>
                    <label style={{ display: "flex" }}>Age</label>
                    <InputNumber
                      placeholder="Age"
                      value={referral.age}
                      onChange={(value) =>
                        handleReferralChange(index, "age", value)
                      }
                      min={0}
                      max={120}
                      style={{ width: "100%" }}
                    />
                  </Col>
                  <Col span={6}>
                    <label style={{ display: "flex" }}>Gender</label>
                    <Select
                      value={referral.gender}
                      onChange={(value) =>
                        handleReferralChange(index, "gender", value)
                      }
                      style={{ width: "100%" }}
                    >
                      <Select.Option value="male">Male</Select.Option>
                      <Select.Option value="female">Female</Select.Option>
                      <Select.Option value="other">Other</Select.Option>
                    </Select>
                  </Col>
                  <Col span={6}>
                    <label style={{ display: "flex" }}>Aadhar</label>
                    <Input
                      placeholder="Aadhar Number"
                      value={referral.aadharNo}
                      onChange={(e) =>
                        handleReferralChange(index, "aadharNo", e.target.value)
                      }
                    />
                  </Col>
                </Row>
              </div>
            ))}

            <br />
            <Button
              size="large"
              type="primary"
              onClick={(e) => {
                e.preventDefault();
                !buttonLoading && handleSubmit();
              }}
              loading={buttonLoading}
            >
              Submit
            </Button>
          </div>
        </Col>
        <Col
          span={12}
          style={{
            display: "flex",
            flexDirection: "column",
            position: "sticky",
          }}
        >
          <div
            className="container"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                width: "400px",
                height: "330px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {capturedImage ? (
                <img
                  src={capturedImage}
                  alt="Captured"
                  width={400}
                  height={330}
                />
              ) : (
                <Webcam
                  className="poscapture"
                  width={400}
                  height={330}
                  ref={webcamRef}
                />
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "10px",
              marginTop: "30px",
              justifyContent: "center",
            }}
          >
            {!capturedImage ? (
              <Button type="primary" onClick={captureImage}>
                Capture
              </Button>
            ) : (
              <>
                <Button type="primary" onClick={recaptureImage}>
                  Recapture
                </Button>
                <Button type="default" onClick={() => setCapturedImage(null)}>
                  Cancel
                </Button>
              </>
            )}
          </div>
        </Col>
      </Row>
      <Modal
        visible={isModalVisible}
        width={450}
        footer={null}
        closable={false}
        centered
        maskClosable={false}
      >
        <TmsPrintTicket
          data={array}
          setData={setArray}
          type="Employee Pass"
          from="Counter"
          externalPrint={externalPrint}
          setExternalPrint={setExternalPrint}
          setButtonLoading={setButtonLoading}
          setPrintTicketModal={setIsModalVisible}
          ticketType={""}
        />
      </Modal>
    </>
  );
};

export default withRouter(EmployeePassAssign);
